<agr-dialog [data]="data" (cancel)="cancel()" class="favorites-dialog" data-test="favorites-dialog">
  <agr-table-v2 class="favorites-dialog__table" [dataSource]="dataSource" [withSelection]="false">
    <ng-container *agrTableTopBar>
      <!-- Intentionally empty to remove the top bar -->
    </ng-container>

    <ng-container *agrTableFiltersWrapper>
      <!-- Intentionally empty to remove the clear filters button -->
    </ng-container>

    <ng-container matColumnDef="name">
      <td mat-cell *matCellDef="let row">
        <a
          #el
          class="text-color--info-500"
          [class]="canBeOrdered(row) ? 'product-search-dialog__product-column' : 'product-search-dialog__product-column--disabled'"
          [class.disabled]="!canBeOrdered(row)"
          (click)="canBeOrdered(row) ? openWizardDialog(row) : $event.preventDefault()"
        >
          {{ row.title }}<br />
        </a>
        <span class="text--label">
          {{ row.externalId }}
        </span>
        <span *ngIf="!canBeOrdered(row)"><br />{{ getUnorderableTranslationKey(row) | translate }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <td mat-cell *matCellDef="let row; let i = index">
        <div *ngIf="skuCanBeOrdered(row) && quantityForms as formGroup" class="column-quantity">
          <ng-container>
            <mat-form-field
              floatLabel="auto"
              subscriptSizing="dynamic"
              appearance="fill"
              (click)="$event.stopPropagation()"
              class="full-width-field spacing--padding-right mat-form-field__no-spacing column-quantity__form-field"
            >
              <mat-label>{{ 'app.favorites.quantity' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="row.orderingInformation?.increaseOrderUnitQuantity ?? 1"
                [min]="row.orderingInformation?.minimumOrderUnitQuantity ?? 0"
                [max]="row.orderingInformation?.maximumOrderUnitQuantity"
                [formControl]="$any(formGroup.at(i))"
              />
              <span
                *ngIf="row.orderingInformation?.orderUnit"
                matIconSuffix
                data-test="table-desktop__input-number-suffix"
                [attr.data-translate-key]="row.orderingInformation?.orderUnit"
              >
                {{ 'unit.' + row.orderingInformation.orderUnit | translate }}
              </span>
            </mat-form-field>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="favoriteStar">
      <td mat-cell *matCellDef="let row; let i = index">
        <app-favorites-star *ngIf="isFavoritesEnabled" class="favorite-star" [isFavoritePage]="true" [skuId]="row.id"></app-favorites-star>
      </td>
    </ng-container>

    <ng-container matColumnDef="addToCart">
      <td class="add-single-item-to-cart spacing--padding-left" mat-cell *matCellDef="let row; let i = index">
        <ng-container *ngIf="quantityForms as formGroup">
          <ng-container>
            <button
              class="add-favorite-button"
              color="primary"
              mat-flat-button
              [disabled]="$any(formGroup.at(i)).invalid || !canBeOrdered(row)"
              (click)="addToCart(row, $any(formGroup.at(i)).value)"
            >
              <mat-icon class="add-favorite-icon">add_shopping_cart</mat-icon>
            </button>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-row *matRowDef="let _; columns: tableColumns"></tr>
  </agr-table-v2>
</agr-dialog>
